import BackButton from "../ui/BackButton";

// Shared shell for /privacy and /terms — plain prose pages, styled to
// match the app's canvas/ink tokens rather than the marketing-heavy
// styling used elsewhere, since these are reference documents, not
// storefront content.
export default function LegalLayout({ title, updated, children }) {
  return (
    <div className="mx-auto max-w-2xl px-4 py-6 pb-16">
      <BackButton fallback="/" fallbackLabel="Home" className="mb-3" />
      <h1 className="font-serif text-2xl text-ink">{title}</h1>
      <p className="mt-1 text-xs text-ink-light">Last updated: {updated}</p>
      <div className="prose-legal mt-6 space-y-5 text-sm leading-relaxed text-ink-light">
        {children}
      </div>
    </div>
  );
}
